import { routesTemplate } from "../routesTemplate";

import RankingScreen from "../../screens/ranking/RankingScreen";

export const rankingStack = [
    routesTemplate('/ranking', RankingScreen, "Ranking"),
];

